<template>
  <div class="page-content">
    <page-template ref="scalesTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :editColumns="editColumns"
    ></page-template>
    <el-dialog title="商城商品档案" :visible.sync="batchEditShow" width="1200px" height="800"
               :close-on-click-modal="false">
      <div class="dateTime">
        选择活动日期：
        <el-date-picker type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" v-model="start"
                        placeholder="选择开始日期时间" :default-time="'00:00:00'"></el-date-picker>
        <span class="center-txt">至</span>
        <el-date-picker type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" v-model="end"
                        placeholder="选择结束日期时间" :default-time="'23:59:59'"></el-date-picker>
        <div v-show="error" class="el-form-item__error">开始时间必须小于结束时间</div>
      </div>
      <batch-modification ref="infoGoods" :isSelect="goodEditListSelect" :tableOptions="batchTableOptions"
                          :batchUpData="batchUpDateList" :dataList="dataList"
      ></batch-modification>
      <div class="btn-box">
        <el-button @click="selectSubmit" type="primary">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';
import batchModification from '@/components/business/batchModification';


export default {
  components: {
    pageTemplate,
    batchModification,
  },
  data() {
    return {
      error: false,
      start: '',
      end: '',
      dataList: [],
      goodEditListSelect: true,
      batchEditShow: false,
      batchUpDateList: [],
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: '商品货号/名称',
            type: 'input',
            prop: 'otherName',
            placeholder: '请输入商品货号/名称',
            isFuzzy: true
          },
        ],
        complex: [
          {
            label: '选择日期:',
            prop: 'createDttms',
            type: 'datetimeRange',
            dateType: 'date',
            span: 24
          },
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '新增',
          code: 'insert',
          callback: this.addGoods
        },
        {
          label: '删除',
          type: this.$utils.buttonType.tableOperate,
          code: 'delete'
        },
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          {label: '商品货号', prop: 'barCode', width: '190', align: 'center'},
          {label: '商品名称', prop: 'goodsName', width: '190', align: 'center'},
          {label: '商品条码', prop: 'artNo', width: '190', align: 'center'},
          {label: '商城价', prop: 'mallRetailPrice', width: '120', align: 'center'},
          {label: '促销价', prop: 'salesPrice', width: '120', align: 'center'},
          {label: '开始时间', prop: 'stratDttm', width: '190', align: 'center'},
          {label: '结束时间', prop: 'endDttm', width: '190', align: 'center'},
          {label: '排序', prop: 'orderNo', width: '120', align: 'center'},
          {
            label: '商品状态',
            prop: 'status',
            width: '120',
            align: 'center',
            enumData: this.$utils.getCacheStatus("mallGoodsSales.status")
          },
        ],
        url: api.mall.saleGoods
      },
      // 编辑字段
      editColumns: {
        labelWidth: '350px',
        span: 24,
        columns: [
          {label: '促销价', prop: 'salesPrice', width: '120', align: 'center', type: 'inputNumber', precision: 2},
          {
            label: '开始时间',
            prop: "stratDttm",
            span: 24,
            type: 'dateTimePicker',
            rule: [{required: true, message: '请选择开始时间', trigger: 'blur'}]
          },
          {
            label: '结束时间',
            prop: 'endDttm',
            span: 24,
            type: 'dateTimePicker',
            rule: [{required: true, message: '请选择结束时间', trigger: 'blur'}]
          }
        ], // 表单label
        url: api.mall.saleGoods
      },
      //添加
      batchTableOptions: {
        columns: [
          {label: '商品货号', prop: 'barCode', width: '190', align: 'center'},
          {label: '商品名称', prop: 'goodsName', width: '120', align: 'center'},
          {label: '商品条码', prop: 'artNo', width: '120', align: 'center'},
          {label: '商城价', prop: 'mallRetailPrice', width: '120', align: 'center'},
          {label: '促销价', prop: 'salesPrice', width: '120', align: 'center', type: "inputNumber", precision: 2},
          {label: '排序', prop: 'orderNo', width: '120', align: 'center', type: "inputNumber"},
        ],
        param: {openMall: true},
        url: api.archives.goodsInfoIncludeSpecs
      },
    };
  },
  created() {
    this.getNewList();
  },
  mounted() {

  },
  watch: {
    start() {
      this.timeCompare();
    },
    end() {
      this.timeCompare();
    }
  },
  methods: {
    addGoods() {
      this.batchEditShow = true;
      this.$nextTick(() => {
        this.$refs["infoGoods"].getTableData();
      })
    },
    selectSubmit() {
       console.log(this.start)
       console.log(this.end)
      let goodsArray = this.$refs['infoGoods'].tabelSelectRows;
      if (goodsArray.length === 0) {
        this.$message({message: "请勾选商品后进行操作！", type: "warning"});
      } else {
        if(this.start == "" && this.end == "" || this.start==""||this.end==""){
        this.$message({message:"请选择活动日期",type:"warning"})
      }else{
          this.$axios.fetchPost(api.mall.saleGoods, {goodsList: goodsArray, stratDttm: this.start, endDttm: this.end})
          .then(data => {
            this.loading = false;
            if (data.code == 200 && data.data) {
              this.batchEditShow = false;
              this.getNewList();
              this.$refs['scalesTemplate'].operationSuccess();
            } else {
              this.$message({message: "请求失败！", type: "error"});
            }
          })
          .catch(err => {
            console.log(err);
            this.$message({message: "请求失败！", type: "error"});
            this.loading = false;
          });
        }
      }
    },

    timeCompare() {
      if (this.start && this.end && this.start > this.end) {
        this.error = true;
      } else {
        this.error = false;
      }
    },

    getNewList() {
      this.$axios.fetchPost(api.mall.saleGoods + '/list').then(data => {
        if (data.code === 200) {
          this.dataList = data.data;
        }
      });
    }
  }
};
</script>

<style scoped>
.priceEdit {
  margin-left: 10px;
  margin-bottom: 20px;
}

.batch-btn {
  margin-bottom: 10px;
}

.dateTime {
  margin-bottom: 10px;
  padding-left: 10px;
  position: relative;
}

.el-form-item__error {
  position: absolute;
  top: 0;
  left: 48%;
  line-height: 2;
}
</style>



// WEBPACK FOOTER //
// src/page/mall/marketing/Sales.vue